export default class ProductService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(product, options) {
    const response = await fetch(`${this.baseUri}/product`, {
      body: JSON.stringify(product),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/product/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/product/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/product`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async getAllLive(options) {
    const response = await fetch(`${this.baseUri}/product/live`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async getPricesLive(productId, siteId, options) {
    const response = await fetch(`${this.baseUri}/product/live/${siteId}/${productId}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async getMultiplePricesLive(productIds, siteId, options) {
    const response = await fetch(`${this.baseUri}/product/live_multiple/${siteId}/?productIds=${productIds.join(',')}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async getSalePricesLive(siteId, options) {
    const response = await fetch(`${this.baseUri}/product/live/sale/${siteId}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async import(products, deleteMissing, options) {
    const response = await fetch(`${this.baseUri}/product/import?deleteMissing=${deleteMissing}`, {
      body: JSON.stringify(products),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return response.ok
  }

  async importSql(deleteMissing, options) {
    const response = await fetch(`${this.baseUri}/product/import/sql?deleteMissing=${deleteMissing}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return response.ok
  }

  async update(id, product, options) {
    const response = await fetch(`${this.baseUri}/receipt/${id}`, {
      body: JSON.stringify(product),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}